export default "__VITE_ASSET__1dc59731__"